import {useTranslation} from "react-i18next";
import {useEffect} from "react";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import OrderByHeaders from "components/ordering/OrderByHeaders";
import DateDisplay from "components/datetime/DateDisplay";

const TableAssetBridge = (props) => {
    const {t: _Tt} = useTranslation("tables");
    const {t: _Tc} = useTranslation("choices");

    useEffect(() => {
        props.orderingRef.current.setHeaders([
            {name: "UID", attr: 0, direction: "asc", active: true, default: true},
            {name: "Tag", attr: 1, direction: "asc", active: false},
            {name: _Tt("containers.full_address"), attr: 2, direction: "asc", active: false},
            {name: _Tt("containers.sensor"), attr: 3, direction: null, active: false, disabled: true},
            {name: _Tt("common.status"), attr: 4, direction: "asc", active: false},
            {name: _Tt("containers.last_communication"), attr: 5, direction: "asc", active: false},
        ]);
    }, []);

    const getStatus = (item) => {
        let templates = [];

        if (item.active) {
            templates.push(<FontAwesomeIcon icon="eye" className="text-secondary me-2" />);
        } else {
            templates.push(<FontAwesomeIcon icon="eye-slash" className="text-secondary me-2" />);
        }
        item.has_alert && templates.push(<FontAwesomeIcon icon="bell" className="text-secondary me-2" />);
        item.has_device && templates.push(<FontAwesomeIcon icon="wifi" className="text-secondary me-2" />);

        return templates.map((el, idx) => <span key={idx}>{el}</span>);
    };

    const stickyHeaderStyle = {
        position: "sticky",
        top: "164px",
        backgroundColor: "white",
    };

    const onClick = (e) => {
        let checkbox;
        if (e.target.type === "checkbox") {
            checkbox = e.target;
        } else {
            checkbox = e.currentTarget.querySelector('input[type="checkbox"]');
            checkbox.checked = !checkbox.checked;
        }

        if (checkbox.checked) {
            props.items.current.addToChosen(e.currentTarget.dataset.idx);
        } else {
            props.items.current.removeFromChosen(e.currentTarget.dataset.idx);
        }
        props.items.current.updatePrev();
        handleButtons();
    };

    const handleCheckAll = (e) => {
        let checkboxList = document.querySelectorAll('input[type="checkbox"]');
        if (e.target.checked) {
            props.setCheckAll(true);
            props.items.current.chosen = props.itemsShow.map((item) => item.uid);
            checkboxList.forEach((checkbox) => {
                checkbox.checked = true;
            });
            handleButtons();
        } else {
            props.setCheckAll(false);
            checkboxList.forEach((checkbox) => {
                checkbox.checked = false;
            });
            props.items.current.clearChosen();
            handleButtons();
        }
    };

    const handleButtons = () => {
        let buttons = {...props.buttonsTB};
        buttons.edit.disabled = props.items.current.chosen.length === 0;
        buttons.delete.disabled = props.items.current.chosen.length === 0;
        props.setButtonsTB(buttons);
    };

    return (
        <table className="table table-striped sticky-horizontal">
            <thead>
                <tr>
                    <th
                        key="-1"
                        style={{
                            width: "26px",
                            ...stickyHeaderStyle,
                        }}
                        className="sticky-top border-bottom-sticky">
                        <input
                            className="form-check-input"
                            type="checkbox"
                            value="all"
                            checked={props.checkAll}
                            onChange={handleCheckAll}
                        />
                    </th>
                    <OrderByHeaders orderingRef={props.orderingRef} styleHeaders={stickyHeaderStyle} />
                </tr>
            </thead>
            <tbody id="list-items">
                {props.itemsShow.length ? (
                    props.itemsShow.map((item) => {
                        return (
                            <tr key={item.uid} data-idx={item.uid} onClick={onClick}>
                                <td>
                                    <input
                                        type="checkbox"
                                        key={item.uid}
                                        data-idx={item.uid}
                                        defaultChecked={props.items.current.chosen.includes(item.uid)}
                                        readOnly={true}
                                    />
                                </td>
                                <td>{item.uid}</td>
                                <td>{item.tag}</td>
                                <td>{item.full_address ? item.full_address : ""}</td>
                                <td>{getStatus(item)}</td>
                                <td>{item.waste_status ? _Tc("containerStatus." + item.waste_status) : ""}</td>
                                <td>
                                    <DateDisplay date={item.measured_at} title={true} />
                                </td>
                            </tr>
                        );
                    })
                ) : (
                    <></>
                )}
            </tbody>
        </table>
    );
};

export default TableAssetBridge;
